import * as React from "react";
function SvgExameImagem(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.916 10.569c0-4.74 3.747-8.685 8.5-8.685s8.5 3.946 8.5 8.685v.002c0 3.184-1.693 6.01-4.246 7.52l.327 3.511-1.486 1.53a1.31 1.31 0 01-.426.294 1.226 1.226 0 01-.963 0 1.312 1.312 0 01-.425-.294 1.423 1.423 0 01-.298-.461 1.501 1.501 0 010-1.12c.07-.177.173-.333.298-.462l2.834-2.916a8.313 8.313 0 01-4.115 1.08 8.36 8.36 0 01-6.055-2.588 8.78 8.78 0 01-2.445-6.096zm1.616.75H7.9c.093.445.268.865.509 1.239L5.997 15.04a7.269 7.269 0 01-1.465-3.721zm3.368-1.5c.093-.445.268-.865.509-1.238L5.997 6.099a7.269 7.269 0 00-1.465 3.72H7.9zm2.726-2.799c-.409.092-.788.254-1.127.47L7.063 4.986a6.79 6.79 0 013.563-1.554v3.59zM9.5 13.647l-2.435 2.507a6.79 6.79 0 003.562 1.553v-3.59a3.517 3.517 0 01-1.127-.47zm2.706.47v3.59a6.79 6.79 0 003.563-1.553l-2.436-2.507a3.517 3.517 0 01-1.127.47zM18.3 11.32a7.268 7.268 0 01-1.466 3.721l-2.412-2.482c.242-.374.416-.793.51-1.24H18.3zm-3.368-1.5H18.3a7.269 7.269 0 00-1.465-3.72L14.423 8.58c.241.374.415.793.509 1.239zM12.205 3.43a6.79 6.79 0 013.563 1.553l-2.435 2.507a3.515 3.515 0 00-1.128-.47V3.43zm-.79 5.002a1.972 1.972 0 011.42.622c.363.378.595.905.595 1.514 0 1.237-.96 2.135-2.014 2.135-1.054 0-2.014-.898-2.014-2.135 0-1.237.96-2.135 2.013-2.136z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgExameImagem);
export default ForwardRef;
